module.exports = __webpack_public_path__ + "img/appAsset-brand--Compliance-dark.9ffcca36.svg";